import React, { useEffect } from 'react';
import { StickyHeader } from './components/StickyHeader';
import { Hero } from './components/Hero';
import { ProblemBlock } from './components/ProblemBlock';
import { SocialProofBar } from './components/SocialProofBar';
import { BenefitsSection } from './components/BenefitsSection';
import { HowItWorks } from './components/HowItWorks';
import { ProductIntro } from './components/ProductIntro';
import { WorkbooksSection } from './components/WorkbooksSection';
import { BonusesSection } from './components/BonusesSection';
import { VisualApproachSection } from './components/VisualApproachSection';
import { ValueStack } from './components/ValueStack';
import { AudienceSection } from './components/AudienceSection';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { ClosingBlock } from './components/ClosingBlock';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { FloatingCTA } from './components/FloatingCTA';
export function App() {
  useEffect(() => {
    document.title = 'CHIMIE VISUELLE™ | Bibliothèque de ressources de chimie prêtes à l’emploi';
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', 'CHIMIE VISUELLE™ est une bibliothèque pédagogique très visuelle pour les professeurs de physique-chimie : 5 volumes pédagogiques et 4 ressources complémentaires, soit 460 pages de schémas, fiches, activités, évaluations et corrigés prêts à imprimer ou à projeter. Paiement unique de 19 €, accès numérique immédiat et accès à vie.');
  }, []);
  return <div className="w-full bg-paper text-ink" data-id="element-0" data-mp="swqchiblnjxz">
      <StickyHeader data-id="element-1" data-mp="35ymodf6r9ya" />
      <main data-id="element-2" data-mp="356sn718lka4">
        <span id="hero-sentinel" aria-hidden="true" data-id="element-3" data-mp="34x29ica5b3w" />
        <Hero data-id="element-4" data-mp="3udavo55x0h34" />
        <ProblemBlock data-id="element-5" data-mp="3udkqq75thefo" />
        <SocialProofBar data-id="element-6" data-mp="3uc9j1w993mja" />
        <BenefitsSection data-id="element-7" data-mp="3uf5ijp0qyj9u" />
        <HowItWorks data-id="element-8" data-mp="d4e9i476jx1z" />
        <ProductIntro data-id="element-9" data-mp="d3mkxdc02zl7" />
        <WorkbooksSection data-id="element-10" data-mp="d45ua5nl4fnm" />
        <BonusesSection data-id="element-11" data-mp="d2bhjemgvtum" />
        <VisualApproachSection data-id="element-12" data-mp="851lhg4kojxt" />
        <ValueStack data-id="element-13" data-mp="86w5ms80s80u" />
        <AudienceSection data-id="element-14" data-mp="83i39jzcvyte" />
        <Testimonials data-id="element-15" data-mp="3gleaym6kt9gr" />
        <Guarantee data-id="element-16" data-mp="3gklau424hi7l" />
        <ClosingBlock data-id="element-17" data-mp="3gm66jx06b771" />
        <FAQ data-id="element-18" data-mp="3gja6a20us6ff" />
        <Footer data-id="element-19" data-mp="3gj1qa19fol00" />
        <div className="h-[54px] md:hidden" aria-hidden="true" data-id="element-20" data-mp="3bmjsjlcitmx6" />
        <SocialProofPopup data-id="element-21" data-mp="3bk702e94zu5v" />
        <FloatingCTA data-id="element-22" data-mp="3qaxrhl6tgr8g" />
      </main>
    </div>;
}